import RangeWidget from 'components/Widgets/RangeWidget';

const RangeTypeField = ({ selectItem, item, setNewSelectItem, disabled }) => {
  return (
    <RangeWidget
      selected={
        selectItem?.value && selectItem?.value !== ' '
          ? [parseInt(selectItem.value)]
          : [parseInt(item?.setting?.find((ran) => ran.param === 'min')?.value)]
      }
      minVal={item?.setting?.find((ran) => ran.param === 'min')?.value}
      maxVal={item?.setting?.find((ran) => ran.param === 'max')?.value}
      onChange={(val) => {
        setNewSelectItem({
          value: `${val}` ?? ' ',
          setting: item?.setting,
        });
      }}
      item={item}
      disabled={disabled}
    />
  );
};

export default RangeTypeField;
